/*
1 - regular user
2 - senior user - has more permissions
3 - admin user
*/
export const userTypeIds = {
  REGULAR: 1,
  SENIOR: 2,
  ADMIN: 3,
};
